import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { cn } from '../../utils/entry.js';
import { getTeamNameAndTitle } from './getTeamNameAndTitle.js';
import { SmartAbbr } from './SmartAbbr.js';
/**
 * JSX component to display the name of a participant, also handles ellipsis if to long name etc.
 *
 * @param param0 props
 * @param param0.participant The participant object
 * @param param0.nameSize Different name sizes
 * @param param0.className Additional class names
 * @returns Component that display the name of a participant.
 */
export function ParticipantName({
  participant,
  nameSize,
  className
}) {
  const [teamName, teamTitle] = useMemo(() => getTeamNameAndTitle(participant, nameSize), [participant, nameSize]);
  return _jsx("span", {
    className: cn('overflow-hidden font-medium text-ellipsis whitespace-nowrap', className),
    children: _jsx(SmartAbbr, {
      title: teamTitle,
      children: teamName
    })
  });
}